import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListingLibLoadingCell() {
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "crm-listing-table-loading-cell",
    blockSize: "20px",
    minInlineSize: "100px",
    inlineSize: "100%",
    backgroundColor: "fill-primary-disabled"
  });
}